<template>
    <div class="member">
        <my-header></my-header>
        <el-row :span="24" class="bg-color">
            <!-- <el-col :span="4" ><div>&nbsp;</div></el-col> -->
            <el-col :span="20" :xs="{span:20,offset:2}" :sm="{span:20,offset:2}" :md="{span:20,offset:2}">
                <nav class="nav">
                    <ul>
                        <li v-for="(list,index) in navList"  :class="{ active:changeRed == index}"  :key="index" @click="active(index)">{{list.text}}</li>
                    </ul>
                </nav>
            </el-col>
            <!-- <el-col :span="4"><div>&nbsp;</div></el-col> -->
        </el-row>
        <el-row class="member_list">
            <!-- <el-col :span="4"><div>&nbsp;</div></el-col> -->
            <el-col :span="20" :xs="{span:20,offset:2}" :sm="{span:20,offset:2}" :md="{span:20,offset:2}">
                <div class="member_hyzx">
                    <ul class="hyzx_left">
                        <li @click="changeActive(1)" :class="{active :num == 1}"><i class="el-icon-s-ticket"></i> 会员企业</li>
                        
                        <li @click="changeActive(3)" :class="{active :num == 3}"><i class="el-icon-mouse"></i> 会员发布</li>
                        <li @click="changeActive(4)" :class="{active :num == 4}"><i class="el-icon-price-tag"></i> 我的企业</li>
                        <li @click="changeActive(2)" :class="{active :num == 2}"><i class="el-icon-s-management"></i> 财务报表</li>
                        <li @click="changeActive(5)" :class="{active :num == 5}"><i class="el-icon-warning-outline"> 会员须知</i></li>
                    </ul>
                    <div v-show="num==1" class="hyzx_right">
                        <div class="minheight">
                            <div class="hyqy_title"><i class="el-icon-s-home"></i>会员企业</div>
                            <div v-for="(list,index) in memberList" :key="index" class="hyzx">
                                
                                <div> <a :href="list.companyUrl" target="_blank"><img :src="list.companyPicture" alt="" ></a> </div>
                                <div class="hyzx_title">{{list.companyName}} <span v-if="list.top == 0">置顶</span> </div>
                                <div class="hyzx_message">{{list.companyDis}}</div>
                                <div class="line_h"></div>
                            </div>
                            <!-- 分页 -->
                            <div id="page-break">
                                <el-pagination
                                background
                                layout="prev, pager, next"
                                :page-size="pageSize"
                                :page="cur"
                                @current-change="currentChange"
                                :total="total"
                                ></el-pagination>
                            </div>
                        </div>                       
                    </div>
                    <div v-show="num==2" class="cwbb_right">
                        <span class="cwbb_font"><i class="el-icon-search"></i>联合会财务报表公示</span>
                        <div class="cwbb">
                            <div>
                                
                                <!-- <div class="cwbb_h"></div> -->
                                <el-select v-model="value" placeholder="请选择">
                                    <el-option
                                        v-for="(item,k) in selectYear"
                                        :key="k"
                                        :value="item">
                                    </el-option>
                                </el-select>
                                <el-button type="primary" @click="queryResult()">查询</el-button>
                            </div>
                            <div>
                                <span class="cwbb_search">查询结果</span>
                                <div class="cwbb_h"></div>
                                <div v-for="(item,i) in result" :key="i" class="result" >
                                    <div>[ {{item.articalAddtime}} ]</div>
                                    <div>{{item.articalTitle}}</div>
                                    <div class="download"><a :href="item.articalUrl" >下载</a></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-show="num==3" class="hyfb_right">
                        <div class="fb_list">
                            
                            <div v-if="isShow">
                                <div class="list_title">我的发布</div>
                                <el-button type="primary" @click="newMsg()" class="newbtn" v-if="show">新的发布</el-button>
                                <div class="list_msg">
                                    <ul v-for="(list,n) in msgList" :key="n">
                                        <li>{{list.title}}<span style="display:block;">{{list.addtime}}</span></li>
                                        <li>文章分类
                                            <span style="display:block;" v-if="list.type === 'LAW'">法律</span>
                                            <span style="display:block;" v-if="list.type === 'FINANCE'">金融</span>
                                            <span style="display:block;" v-if="list.type === 'LOGISTICS'">物流</span>
                                            <span style="display:block;" v-if="list.type === 'EXHIBTION'">展会</span>
                                            <span style="display:block;" v-if="list.type === 'LEASE'">租赁共享</span>
                                            <span style="display:block;" v-if="list.type === 'BUSINESS'">商务考察</span>
                                            <span style="display:block;" v-if="list.type === 'TRANSLATE'">翻译公证</span>
                                            <span style="display:block;" v-if="list.type === 'AID'">企业互助</span>
                                            <span style="display:block;" v-if="list.type === 'TALENT'">人才交流</span>
                                            <span style="display:block;" v-if="list.type === 'CHARITABLE'">慈善文化</span>
                                            <span style="display:block;" v-if="list.type === 'YDYL'">一带一路</span>
                                            <span style="display:block;" v-if="list.type === 'POLICY'">政策共享</span>
                                            <span style="display:block;" v-if="list.type === 'FOUNDATION'">互助基金</span>
                                            <span style="display:block;" v-if="list.type === 'AFFAIRS'">财务管理</span>
                                            <span style="display:block;" v-if="list.type === 'PROJECTSHOW'">投融资项目公示</span>
                                        </li>
                                        <li>审核状态
                                            <span v-if="list.articalCheck == 0" style="display:block;">审核通过</span>
                                            <span v-if="list.articalCheck == 1" style="display:block;">未通过</span>
                                            <span v-if="list.articalCheck == 2" style="display:block;">审核中</span>
                                        </li>
                                        <li class="list_button">
                                            <el-button type="primary" @click="getDetailed(list)">编辑</el-button>
                                            <el-button type="danger" plain v-if="list.issubmit == 1"  @click="getDel(list)">删除</el-button>
                                            <span v-if="list.issubmit == 0" >删除申请中</span>
                                        </li>
                                    </ul>
                                    <div>
                                        <el-pagination
                                            background
                                            :page="tabPage"
                                            @current-change="handlecurrentChange"
                                            :page-size="tabPagesize"
                                            layout="prev, pager, next"
                                            :total="tabtotal">
                                        </el-pagination>
                                    </div>
                                </div>
                            </div>
                            
                            <div v-else>
                                <div class="list_title">新建发布</div>
                                <div style="margin:10px 0;padding:0 10px;">
                                    <div style="margin:10px 0;font-size:16px;">发布分类</div> 
                                    <el-select v-model="sort" placeholder="请选择">
                                        <el-option
                                        v-for="item in options"
                                        :key="item.value"
                                        :label="item.name"
                                        :value="item.value">
                                        </el-option>
                                    </el-select>
                                    
                                </div>
                                <div style="margin:10px 0;padding:0 10px;">
                                    <div style="margin:10px 0;font-size:16px;">发布标题</div>
                                    <el-input v-model="title" placeholder="请输入内容"  style="font-size:16px;"></el-input>
                                </div>
                                <div style="margin:10px 0;padding:0 10px;">
                                    <div style="margin:10px 0;font-size:16px;">上传附件</div>
                                    <el-upload
                                        class="upload-demo"
                                        ref="upload"
                                        action="http://152.136.53.33:5081/file/upload"
                                        :multiple="true"
                                        :limit="9"
                                        name="files"
                                        :on-success="handSuccessUpload"
                                        :file-list="uploadList"
                                        :auto-upload="false"
                                        :http-request="uploadFile"
                                        >
                                        <el-button slot="trigger" type="primary">选取文件</el-button>
                                        <el-button style="margin-left: 10px;" type="success" @click="submitUpload">上传文件</el-button>
                                    </el-upload>
                                </div>
                                <div style="margin:10px 0;padding:0 10px;">
                                    <div style="margin:10px 0;font-size:16px;">发布内容</div>
                                    <quill-editor 
                                        v-model="content"
                                        ref="myTextEditor"
                                        :options="editorOption"
                                        style="height:280px;"
                                        @blur="onEditorBlur($event)"
                                        @focus="onEditorFocus($event)"
                                        @change="onEditorChange($event)">
                                    </quill-editor>
                                    <el-button type="primary" @click="saveMsg()" style="margin-top:40px;">发布</el-button>
                                    <el-button type="primary" plain @click="back()" style="margin-top:40px;">取消</el-button>
                                </div>
                            </div>
                            <!-- 编辑 -->
                            <el-dialog title="编辑" :visible.sync="dialogFormVisible">
                                <el-form >
                                    <el-form-item label="文章标题" :label-width="formLabelWidth">
                                        <el-input v-model="seayInfo.title" autocomplete="off"></el-input>
                                    </el-form-item>
                                    <el-form-item label="文章附件">
                                        <template>
                                            <ul v-for="(list,m) in seayInfo.annexes" :key="m">
                                                <li>{{list.name}} <el-button type="danger" @click="getDesl(list.id,m)">X</el-button></li>
                                            </ul>
                                            <el-upload
                                                class="upload-demo"
                                                :action="uploadURL"
                                                name="files"
                                                :on-success="handSuccessUploads"
                                                :on-error="handFail"
                                                >
                                                <el-button size="small" type="primary">上传文件</el-button>
                                                <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
                                            </el-upload>
                                        </template>
                                    </el-form-item>
                                    <el-form-item label="文章标题" :label-width="formLabelWidth">
                                        <!-- <el-input  autocomplete="off"></el-input> -->
                                        <template style="">
                                            <quill-editor 
                                                v-model="seayInfo.content"
                                                ref="myTextEditor"
                                                :options="editorOption"
                                                style="height:200px;margin-top:30px;margin-bottom:34px;"
                                                @blur="onEditorBlur($event)"
                                                @focus="onEditorFocus($event)"
                                                @change="onEditorChange($event)">
                                            </quill-editor>
                                        </template>
                                        
                                    </el-form-item>
                                </el-form>
                                <div slot="footer"  id="dialog-footer">
                                    <el-button @click="dialogFormVisible = false">取 消</el-button>
                                    <el-button type="primary" @click="saveInfo()">确 定</el-button>
                                </div>
                            </el-dialog>
                        </div>
                    </div>
                    <div v-show="num==4" class="hyfb_right">
                        <div class="fb_list">
                            <div class="list_title">我的企业</div>
                            <div v-if="companyIshome">
                                <div  style="background-color:#f8f8f8;width:100%;height:300px;box-sizing:border-box;padding:20px 10px;" v-for="(list,index) in memberList" :key="index">
                                    <div style="float:left;width:20%;"> <a :href="list.companyUrl" target="_blank"><img style="width:100%;height:200px;" :src="list.companyPicture" alt="" ></a> </div>
                                    <!-- <div style="float:left;">{{list.companyName}} <span v-if="list.top == 0">置顶</span> </div> -->
                                    <div style="float:right;width:78%;box-sizing:border-box;padding:20px 0;">
                                        
                                        <span>{{list.companyDis}}</span><br>
                                        <el-button type="primary" plain @click="getDetail()">编辑</el-button>
                                    </div>
                                    <!-- <div>编辑</div> -->
                                    <!-- <div class="line_h"></div> -->
                                </div>
                            </div>
                            <div v-else>
                                <el-form ref="form" :model="form" label-width="80px">
                                    <el-form-item label="企业名称">
                                        <el-input v-model="companyInfo.companyName" class="inputMsg"></el-input>
                                    </el-form-item>
                                    <el-form-item label="简介">
                                        <el-input type="textarea" v-model="companyInfo.companyDis" class="inputMsg"></el-input>
                                    </el-form-item>
                                    <el-form-item label="网站连接">
                                        <el-input v-model="companyInfo.companyUrl" class="inputMsg"></el-input>
                                    </el-form-item>
                                    <el-form-item label="企业图片">
                                        <el-upload
                                            class="upload-demo"
                                            action="http://152.136.53.33:5081/img/upload"
                                            :on-success="handSuccess"
                                            :on-error="handFail"
                                            >
                                            <el-button size="small" type="primary">点击上传</el-button>
                                            <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
                                        </el-upload>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-button type="primary" @click="updataCompany()">更新</el-button>
                                        <el-button>取消</el-button>
                                    </el-form-item>
                                </el-form>
                            </div>
                        </div>
                    </div>
                    <div v-show="num==5" class="hyfb_right">
                        <div class="fb_list">
                            <div class="list_title">会员须知</div>
                            <div class="msg_list">
                                <div class="msg_item">
                                    <span class="msg_title">团体会员条件</span>
                                    <p>(一)在俄罗斯联邦境内依法登记注册的企业法人</p>
                                    <p>(二)俄联邦各州、自治区、直辖市和中心城市的企业团体</p>
                                </div>
                                <div>
                                    <span class="msg_title">个人会员条件</span>
                                    <p>(一)关心和支持本会工作，并在企业和经济研究领域有显著成绩者</p>
                                    <p>(二)本会团体会员的现任领导</p>
                                    <p>(三)非团体会员的企业家(雇主)</p>
                                </div>
                                <span class="msg">经申请人提出申请，本会理事长办公会核准并发给会员证书后，即成为本会会员。</span>
                                <div>
                                    <span class="msg_title">会员享有权利</span>
                                    <p>一、选举权和被选举权</p>
                                    <p>二、参加本会组织的活动</p>
                                    <p>三、享受本会提供的服务</p>
                                    <p>四、向本会提出有关意见、建议，并对本会的工作进行批评与监督</p>
                                    <p>五、退会自由</p>
                                </div>
                                <div>
                                    <span class="msg_title">会员履行义务</span>
                                    <p>一、遵守本会章程、执行本会决议</p>
                                    <p>二、关心和支持本会的工作</p>
                                    <p>三、承担本会委托的有关工作</p>
                                    <p>四、向本会提供有关情况、信息、统计数据和其他资料</p>
                                    <p>五、按规定缴纳会费</p>
                                </div>
                                <span class="msg">会员违反法律、法规或者不遵守本会章程，视情节轻重，本会可取消其会员资格</span>
                                <div>
                                    <span class="msg_title">荣誉会员条件</span>
                                    <span class="msg">符合下列条件之一者，可授予荣誉会员称号：</span>
                                    <p>1、不再担任本会的常务理事、理事，身体健康，仍热心本会工作并做出突出贡献者</p>
                                    <p>2、为企业做出突出贡献的离任企业家(雇主)</p>
                                    <p>3、在企业改革、管理、发展和维权等方面有影响或者有贡献的知名专家、学者</p>
                                    <p>4、关心和支持本会工作并对本会做出贡献的社会知名人士</p>
                                    <p>5、对本会一贯友好并做出贡献的国际友人、港澳台同胞、海外侨胞</p>
                                </div>
                                <span class="msg">荣誉会员可参加本会的有关活动，不缴纳会费，不享有选举权和被选举权</span>
                            </div>
                        </div>
                    </div>
                </div>
            </el-col>
            <!-- <el-col :span="4"><div>&nbsp;</div></el-col> -->
        </el-row>
        <my-footer></my-footer>
    </div>
</template>

<script>
import MyHeader  from '../headerPage'
import MyFooter  from '../footerPage'
import { quillEditor } from 'vue-quill-editor'
import quillConfig from '../../../untils/quill-config'
export default {
    components:{MyHeader,MyFooter,quillEditor},
    data() {
        return {
            changeRed:2,
            navList:[{
                text:"首页"
            },{
                text:"简介概况"
            },{
                text:"会员中心"
            },{
                text:"联系我们"
            }],
            num:1,
            memberList:[],
            total:0,
            selectYear:[],
            value: '',
            cur:1,
            pageSize:10,
            result:[],
            // 
            // showedstyle:true,
            // msgList:[],
            isShow:true,
            show:true,
            userId:sessionStorage.getItem('userId'),
            tabPage:1,
            tabPagesize:10,
            tabtotal:0,
            msgList:[],
            sort:'',
            options:[],
            title:"",
            content:'',
            editorOption:quillConfig,
            form:{
                name:'',
                desc:"",
                link:'',
            },
            companyPicture:"",
            companyIshome:false,
            dialogFormVisible:false,
            formLabelWidth:"120px;",
            seayInfo:"",
            companyInfo:{},
            fileData: '',  // 文件上传数据（多文件合一）
            uploadList: [],   // upload多文件数组
            fileName:"",
            fileUrl:"",
            uploadURL:"",
        }
    },
    mounted() {
        this.membersList();
        this.queryYear();
        var w = document.documentElement.clientWidth;
        if(w < 768){
            this.showstyle = true;
            this.showedstyle = false;
        }else{
            this.showstyle = false
            this.showedstyle =true
        };

        this.getPublic();
        this.getArticalType();
        this.getCompany();
    },
    methods: {
        //左侧切换
        changeActive(k){
            this.num = k;
            //判断切到为财务报表，会员发布  需要会员状态，不是会员不能查看
            if(this.num == 2){
                if(this.userId == null){
                // console.log('aaaaa');
                    this.$alert('您暂未成为会员,无法查看财务报表', '提示', {
                        confirmButtonText: '确定',
                        callback: action => {
                            //console.log('点了确定');
                            // this.$router.push({name:"homePage"})
                        }
                    });
                } 
            }else if(this.num == 3){
                if(this.userId == null){
                // console.log('aaaaa');
                    this.$alert('您暂未成为会员,无法查看', '提示', {
                        confirmButtonText: '确定',
                        callback: action => {
                            //console.log('点了确定');
                            // this.$router.push({name:"homePage"})
                        }
                    });
                }
            }else if(this.num == 4){
                if(this.userId == null){
                // console.log('aaaaa');
                    this.$alert('您暂未成为会员,无法查看', '提示', {
                        confirmButtonText: '确定',
                        callback: action => {
                            //console.log('点了确定');
                            // this.$router.push({name:"homePage"})
                        }
                    });
                }
            }
        },
        onEditorBlur(editor){//失去焦点事件 

        },
        onEditorFocus(editor){//获得焦点事件

        },
        onEditorChange({editor,html,text}){//编辑器文本发生变化
            //this.content可以实时获取到当前编辑器内的文本内容
            // console.log(this.content);
        },
        //分页
        currentChange(page){
            this.cur = page
            this.membersList();
        },
        //会员企业
        membersList(){
            this.$axios.get("/getMembers/"+this.cur+"/"+this.pageSize).then(res=>{
                // console.log(res);
                this.memberList = res.data.data.list;
                this.total = res.data.data.total;
            })
        },
        //查询内容
        queryYear(){
            this.$axios.get('/getFinanceYear').then(res=>{
                this.selectYear = res.data.data;
            })
        },
        //查询结果
        queryResult(){
            if(this.userId == null){
                // console.log('aaaaa');
                this.$alert('您暂未成为会员,无法查看', '提示', {
                    confirmButtonText: '确定',
                    callback: action => {
                        //console.log('点了确定');
                        // this.$router.push({name:"homePage"})
                    }
                });
                return;
            }
            this.$axios.get('/getFinanceByYear/'+this.value).then(res=>{
                if(res.data.success){
                    this.result = res.data.data;
                }
            })
        },
        //切换导航
        active(index){
            this.changeRed = index;
            if(index == 0){
                this.$router.push({name:"homePage"})
            }else if(index == 1){
                this.$router.push({name:"surveyPage"})
            }else if(index == 2){
                this.$router.push({name:"memberPage"})
            }else if(index == 3){
                this.$router.push({name:"aboutPage"})
            }
        },
        handlecurrentChange(val){
            this.tabPage = val;
            this.getPublic();
        },

        //发布列表
        getPublic(){
            this.$axios.get('/getPublishArticals/'+this.tabPage+'/'+this.tabPagesize+'/'+this.userId).then(res=>{
                if(res.data.success){
                    // console.log(res.data);
                    this.msgList = res.data.data.list;
                    this.tabtotal = res.data.data.total;
                }
            })
        },
        //发布分类的列表
        getArticalType(){
            this.$axios.get('/getArticalType').then (res=>{
                // console.log(res.data);
                if(res.data.success){
                     this.options = res.data.data;
                }
            })
        },
        newMsg(){
            if(this.userId == null){
                // console.log('aaaaa');
                    this.$alert('您暂未成为会员,无法发布消息', '提示', {
                        confirmButtonText: '确定',
                        callback: action => {
                            //console.log('点了确定');
                            // this.$router.push({name:"homePage"})
                        }
                    });
                    return;
            }
            this.isShow =! this.isShow;
        },
        back(){
            this.isShow= true;
            if(this.sort !=""){
                this.sort = ''
            }
            if(this.title !=""){
                this.title = ''
            }
            if(this.content !=""){
                this.content = ''
            }
        },
         //发布信息
        saveMsg(){
            if(!this.sort){
                this.$message.error('请选择发布分类');
                return
            }
            if(!this.title){
                this.$message.error('请输入发布标题');
                return
            }
            if(!this.content){
                this.$message.error('请输入需要发布的内容');
                return
            }
            this.$confirm('确定发布信息吗?, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            }).then(() => {
                this.$axios.post('/saveArtical',{
                    userId:this.userId,
                    type:this.sort,
                    title:this.title,
                    content:this.content,
                    fileName:this.fileName,
                    fileUrl:this.fileUrl,
                }).then(res=>{
                    this.isShow = true;
                    this.getPublic();
                }).catch(err=>{

                })
                this.sort="";
                this.title="";
                this.content="";
            }).catch(() => {        
            });
        },
        //删除
        getDel(list){
            this.$confirm('确定删除'+list.title+'?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios.post('/delPublishArtical',{
                    userId:this.userId,
                    title:list.title,
                    mykey:list.id,
                }).then(res=>{
                    if(res.data.success){
                        this.$message({
                            type: 'success',
                            message: '删除申请成功!'
                        });
                        this.getPublic();
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
            
        },
        //我的企业 编辑 切换
        getDetail(){
            this.companyIshome = false;
        },
        // 我的企业  上传图片
        handSuccess(response, file, fileList){
            this.$message({
                type: 'success',
                message: '上传成功'
            }); 
            this.companyInfo.companyPicture = response.data;
        },
        handFail(err, file, fileList){

        },
        //编辑会员发布
        getDetailed(list){
            this.dialogFormVisible = true;
            this.uploadURL = 'http://152.136.53.33:5081/ann/upload/'+list.id
            this.$axios.get('/getPublishArticalsDetail/'+list.id).then (res=>{
                //console.log(res.data);
                if(res.data.success){
                    //console.log(res.data.data);
                    this.seayInfo = res.data.data;
                }
            })
            

            
            
        },
        saveInfo(){
            this.$axios.post('/upDatePublishArtical',{
                    id:this.seayInfo.id,
                    title:this.seayInfo.title,
                    content:this.seayInfo.content,
                }).then(res=>{
                    if(res.data.success){
                         this.$alert('更新成功', '提示', {
                            confirmButtonText: '确定',
                        });
                        this.dialogFormVisible = false;
                    }else{
                        this.$alert(res.data.message, '提示', {
                            confirmButtonText: '确定',
                        // callback: action => {
                        //     this.$message({
                        //     type: 'info',
                        //     message: `action: ${ action }`
                        //     });
                        // }
                        });
                    }
                })
        },
        getCompany(){
            this.$axios.get('/getCompanyInfo/'+this.userId).then (res=>{
                //console.log(res.data);
                if(res.data.success){
                    this.companyInfo = res.data.data;
                }
            })  
        },
        updataCompany(){
            var reg=/(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/;
            if(!reg.test(this.companyInfo.companyUrl)){
                this.$alert('请输入正确的网站链接', '提示', {
                    confirmButtonText: '确定',
                });
            }
            this.$axios.post('/updateCompanyInfo',{
                companyName:this.companyInfo.companyName,
                companyDis:this.companyInfo.companyDis,
                companyUrl:this.companyInfo.companyUrl,
                companyPicture:this.companyInfo.companyPicture,
                mykey:this.userId,
            }).then(res=>{
                if(res.data.success){
                    this.$message({
                        type: 'success',
                        message: '更新成功'
                    });
                }else{
                    this.$message({
                        type: 'error',
                        message: '更新失败'
                    });
                }
            })
        },
        
        // 上传文件
		uploadFile(file) {
		    this.fileData.append('files', file.file);  // append增加数据
		},
        submitUpload(){
            this.fileData = new FormData();  // new formData对象
            this.$refs.upload.submit();  // 提交调用uploadFile函数
            
            this.$axios.post('http://152.136.53.33:5081/file/upload',this.fileData).then(res=>{
                //(res.data);
                if(res.data.success){
                    this.$alert('上传成功', '提示', {
                        confirmButtonText: '确定',
                    });
                    this.fileName = res.data.data.fileName;
                    this.fileUrl = res.data.data.fileUrl;
                }
            })
        },
        //删除某一个附件
        getDesl(id,m){

            this.$axios.get('/delFile/'+id).then (res=>{
                //console.log(res.data);
                if(res.data.success){
                    this.$message({
                        message: '删除成功！',
                        type: 'success'
                    });
                    this.seayInfo.annexes.splice(m, 1);
                }
            }) 
        },
        //上传新的附件
        getWordAdd(){
            this.$axios.post('http://152.136.53.33:5081/file/upload',this.fileData).then(res=>{
                //(res.data);
                if(res.data.success){
                    this.fileName = res.data.data.fileName;
                    this.fileUrl = res.data.data.fileUrl;
                }
            })
        },
        handSuccessUpload(response, file, fileList){
            // console.log(response)
            // console.log(fileList)
        },
        handSuccessUploads(response, file, fileList){
            // console.log(response)
            // console.log(this.seayInfo.annexes)
            var resDATA= response.data;
            this.seayInfo.annexes.push(resDATA[0]);
            // console.log(response)
            // console.log(fileList)
        },
    },
}
</script>

<style scoped  >
/* 导航 */
    .bg-color{
        background-color: #DBDBDB;
    }
    .nav{
        width:100%;
        height:auto;
        background-color: #DBDBDB;
    }
    .nav ul{
        height:40px;
        margin:0 auto;
        
    }
    .nav ul li {
        float:left;
        width:25%;
        box-sizing: border-box;
        padding:10px 10px;
        color:#5B5B5B;
        font-size:20px;
        font-weight:600;
        text-align: center;
        cursor:pointer;
    }
    .nav ul li.active{
        color:#fff;
        background-color: #1f3356;
    }




    .member_list{
        margin-top:40px;
    }
    .member {
        width:100%;
        height:auto;
    }
    .member .member_hyzx{
        width:100%;
        height:100%;
    }
    .member_hyzx .hyzx_left{
        float:left;
        width:16%;
        height:auto;
    }
    .member_hyzx .hyzx_left li{
        min-width:130px;
        min-height:60px;
        text-align:center;
        line-height:60px;
        font-size:20px;
        background-color: #fff;
    }
    .member_hyzx .hyzx_left li.active{
        background-color: #FE9900;
        color:#fff;
    }

    /* 会员企业 */
    .hyzx_right .minheight{
        min-height: 700px;
    }
    .member_hyzx .hyzx_right{
        float:right;
        width:84%;
        height:100%;
    }
    .member_hyzx .hyzx_right  .hyqy_title{
        
        width:100%;
        height:40px;
        line-height:40px;
        box-sizing: border-box;
        padding:0 20px;
        background-color: #1f3358;
        color:#fff;
        font-size:20px;
        font-weight:600;
    }
    .member_hyzx .hyzx_right .hyzx{
        width:100%;
        height:200px;
        background-color: #f8f8f8;
        box-sizing: border-box;
        padding:20px 20px;
    }
    
    .member_hyzx .hyzx_right div img{
        float:left;
        width:250px;
        height:150px;
        margin-right:20px;
    }
    .member_hyzx .hyzx_right .hyzx_title{
        font-size:20px;
        font-weight:600;
        color:#666;
        margin-bottom:10px;
        /* box-sizing: border-box; */
        /* padding-top:30px; */
    }
    .member_hyzx .hyzx_right .hyzx_title span{
        color:#fff;
        background-color: #fe9900;
    }
    .member_hyzx .hyzx_right .hyzx_message{
        color:#666;
        font-size:16px;
        box-sizing: border-box;
        padding-top:6px;
        overflow:hidden;
        text-overflow:ellipsis;
        display:-webkit-box;
        -webkit-box-orient:vertical;
        -webkit-line-clamp:4;
    }
    .member_hyzx .hyzx_right .line_h{
        float: left;
        width:100%;
        height:1px;
        background-color: #ccc;
        margin-top:24px;
    }
    /* 财务报表 */
    .member_hyzx .cwbb_right{
        float:right;
        width:84%;
        height:100%;
    }
    .member_hyzx .cwbb_right .cwbb{
        width:100%;
        height:auto;
        min-height:900px;
        box-sizing: border-box;
        padding:20px 20px;
        background-color: #f8f8f8;
    }
    .member_hyzx .cwbb_right .cwbb_font{
        display:block;
        width:100%;
        height:40px;
        line-height:40px;
        box-sizing: border-box;
        padding:0 20px;
        background-color: #1f3358;
        color:#fff;
        font-size:20px;
        font-weight:600;
        /* margin:20px 0; */
    }
    .member_hyzx .cwbb_right .cwbb .cwbb_search{
        display:block;
        color:#1f3358;
        font-size:20px;
        font-weight:600;
        margin:20px 0;
    }
    .member_hyzx .cwbb_right .cwbb .cwbb_h{
        width:100%;
        height:1px;
        background-color: #ccc;
        border:1px solid #ccc;
        /* margin:10px 0; */
    }
    .member_hyzx .cwbb_right .cwbb .el-select{
        margin:20px 0;
    }
    /* 结果 */
    .result{
        width:100%;
        height:50px;
    }
    .result div{
        float:left;
        line-height:50px;
        margin-right:10px;
    }
    .result .download{
        float:right;
    }


    .el-pagination{
        float:right;
    }
    .el-pagination--small .el-pager .number{
        font-size:22px;
    }

    /* 新增的会员发布 */
    .hyfb_right{
        float:right;
        width:84%;
    }

    .list_title{
        width:100%;
        height:40px;
        line-height:40px;
        box-sizing: border-box;
        padding:0 20px;
        color:#fff;
        font-size:20px;
        font-weight:bold;
        background-color:#1f3358;
    }
    .list_msg{
        width:100%;
        height:auto;
        min-height:1000px;
        font-size:21px;
        background-color:#eee;
    }
    .list_msg ul{
        width:98%;
        min-height:110px;
        box-sizing: border-box;
        padding:10px 10px;
        margin:10px 10px 20px 10px;
        border-radius: 10px;
        background-color:#fff;
        
    }
    .list_msg ul li{
        float:left;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: justify;
        box-sizing: border-box;
        padding:20px 20px;
    }
    .list_msg ul li:nth-child(1){
        width:40%;
        font-weight:600;
        
    }
    .list_msg ul li:nth-child(2){
        width:10%;
    }
    .list_msg ul li:nth-child(3),.list_button{
        width:24%;
        box-sizing: border-box;
        /* margin:10px 0; */
    }
    .el-input{
        width:30%;
    }
    .el-dialog__wrapper {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        overflow: auto;
        margin: 0;
        /* height:500px; */
    }
    .el-dialog {
        position: relative;
        margin: 0 auto 0.666667rem;
        border-radius: 0.026667rem;
        -webkit-box-shadow: 0 0.013333rem 0.04rem rgba(0, 0, 0, .3);
        box-shadow: 0 0.013333rem 0.04rem rgba(0, 0, 0, .3);
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        width: 50%;
        height:500px;
    }
    #el-dialog__footer{
        margin-top:40px;
    }
    .msg_list{
        width:100%;
        height:auto;
        min-height:900px;
        box-sizing: border-box;
        padding:20px 20px;
        background-color: #f8f8f8;
    }
    .msg_title{
        display:block;
        color:#333;
        font-size: 24px;
        font-weight:bold;
        margin-bottom:6px;
    }
    .msg_list p{
        color:#333;
        font-size:21px;
        margin-bottom:6px;  
    }
    .msg_list .msg{
        display: block;
        color:#666;
        font-size:20px;
        margin-bottom:6px;
    }
</style>

<style >
    .inputMsg{
        color:#000;
        font-size:20px;
    }
    .inputMsg .el-input__inner{
        height:50px;
        line-height:50px;
    }
</style>


// WEBPACK FOOTER //
// src/components/ZH-CN/memberPage.vue